/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 125px)',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 30,
  },
  container2: {
    width: 'calc(100% + 120px)',
    display: 'flex',
    maxHeight: 900,
    flexDirection: 'row',
    paddingBottom: 50,
    marginLeft: -20,
  },
  container3: {
    width: 'calc(100% + 225px)',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 50,
    marginLeft: 75,
    marginRight: 75,
    maxHeight: 400,
  },
  container4: {
    width: 'calc(100% + 225px)',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 50,
    marginLeft: -20,
  },
  columnWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 100,
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 200,
  },
  rightColumn2: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 30,
  },
  leftImage: {
    width: '275%',
    marginLeft: 10,
  },
  scanImages: {
    width: '100%',
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: 5,
    marginBottom: 15,
  },
  topImage: {
    width: '85%',
    margin: 5,
  },
  image2: {
    width: '35%',
    display: 'flex',
    margin: '0 8px 0 0',
    boxShadow: '6px 6px 10px #9E9E9E',
  },
  image3: {
    width: '20%',
    display: 'flex',
    margin: '0 36px 0 0',
    boxShadow: '6px 6px 10px #9E9E9E',
  },
  image4: {
    width: '30%',
    display: 'flex',
    margin: '0 8px 0 0',
    boxShadow: '6px 6px 10px #9E9E9E',
  },
  imageColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 8px 0 0',
  },
  imageText: {
    paddingLeft: 10,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    marginTop: -20,
    paddingBottom: 25,
    fontStyle: 'italic',
  },
  video: {
    width: 'calc(100% + 125px)',
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height: '100%',
    paddingBottom: 30,
  },
}));

const AdditionalCaseStudyImaging01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.text}>
        POSLUMA Images
      </Typography>
      <div className={classes.video}>
        <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACS_1.path} controls />
      </div>
      <div className={classes.container}>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            PET
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_PET.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_PET.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            FUSED
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_FUSED.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_FUSED.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            CT
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_CT.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MAIN_CT.alt}
          />
        </div>
      </div>
      <Typography variant="body1" className={classes.text}>
        Extrapelvic LNs
      </Typography>
      <div className={classes.container2}>
        <img
          className={classes.image2}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_PET.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_PET.alt}
        />
        <img
          className={classes.image2}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_FUSED.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_FUSED.alt}
        />
        <img
          className={classes.image2}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_CT.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].EXTRAPELVIC_CT.alt}
        />
      </div>
      <Typography variant="body1" className={classes.text}>
        Multiple Bone Lesions
      </Typography>
      <div className={classes.container3}>
        <img
          className={classes.image3}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_PET.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_PET.alt}
        />
        <img
          className={classes.image3}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_FUS.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_FUS.alt}
        />
        <img
          className={classes.image3}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_CT.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_SIDE_CT.alt}
        />
      </div>
      <div className={classes.container4}>
        <img
          className={classes.image4}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_PET.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_PET.alt}
        />
        <img
          className={classes.image4}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_FUS.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_FUS.alt}
        />
        <img
          className={classes.image4}
          src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_CT.path}`}
          alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[1].MULTIPLE_BONE_LESIONS_FRONT_CT.alt}
        />
      </div>
    </>
  );
};

export default AdditionalCaseStudyImaging01;
